<!-- <h1 mat-dialog-title>{{mode == 'edit' ? 'Edit category' : 'Add Category'}}</h1> -->
<div mat-dialog-content>

	<div class="main-section-box">
        <h5 class="modal_title">{{mode == 'edit' ? 'Edit category' : 'Add Category'}}</h5>
	

		<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>
		<!-- <mat-form-field appearance="outline"> -->
			<div class="fl">
				<div class="label-bx">
					<mat-label>Category Name</mat-label>
					<mat-label id="toggle-label">Visible</mat-label>
				</div>
				<div class="input-toggle-bx">
					<input (ngModelChange)="onInputChange()" matInput [(ngModel)]="category.name" name="name" >
					<div id="toggle-bx">
						<mat-slide-toggle [checked]="category.visible" (change)="changeCatVisibility($event)"></mat-slide-toggle>
					</div>
				</div>
			</div>
		<!-- </mat-form-field> -->

		<!-- <mat-form-field appearance="outline"> -->
			<!-- <div class="fl_toggle">
				<mat-label>Visible</mat-label>
				<mat-slide-toggle [checked]="category.visible" (change)="changeCatVisibility($event)"></mat-slide-toggle>
			</div> -->

		<!-- </mat-form-field> -->

		<button mat-button (click)="addSubCategories()" class="add-sub-cat-btn">Add Sub Category
			<!-- <mat-icon>add</mat-icon> -->
		</button>

		<!-- <div *ngIf="category?.subCategories?.length" id="subcat-list">
			<ng-container *ngFor="let subCat of category.subCategories; let i = index">
				<div class="wrap-cat" draggable="true" (dragover)="dragSubcatOver($event, category.subCategories)" (dragstart)="dragSubcatStart($event)" (dragend)="dragSubcatEnd($event)" [attr.data-myId]="subCat.id">
					<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000" class="subcat-drag-handle"><path d="M160-360v-80h640v80H160Zm0-160v-80h640v80H160Z"/></svg>
					<mat-label class="subcat-name-label">Name</mat-label>
					<input (ngModelChange)="onInputChange()" [(ngModel)]="subCat.name" name="name" matInput required>

					<div class="fl_toggle">
						<mat-label>Visible</mat-label>
						<mat-slide-toggle [checked]="subCat.visible" (change)="changeSubCatVisibility($event , i)"></mat-slide-toggle>
					</div>

					<button class="rem_btn" mat-button (click)="remove(i)" style="margin-bottom: 10px;
					max-width: 20px;
					padding: 5px;">
						<mat-icon>delete</mat-icon>
					</button>
				</div>
			</ng-container>
		</div> -->

		<div *ngIf="category && category.subCategories && category.subCategories.length > 0" class="fl" style="margin-bottom: 0px;">
			<div class="label-bx2">
				<mat-icon id="handle-icon">apps</mat-icon>
				<mat-label id="name">Sub Category Name</mat-label>
				<mat-label id="delete-label">Delete</mat-label>
				<mat-label id="toggle-label">Visible</mat-label>
			</div>
		</div>
		<div *ngIf="category?.subCategories?.length" id="subcat-list" cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
			<div class="fl example-box" style="margin-bottom: 12px;" *ngFor="let subCat of category.subCategories; let i = index" cdkDrag>
				<!-- <div *ngIf="i===0" class="label-bx2">
					<mat-icon id="handle-icon">apps</mat-icon>
					<mat-label id="name">Sub Category Name</mat-label>
					<mat-label id="delete-label">Delete</mat-label>
					<mat-label id="toggle-label">Visible</mat-label>
				</div> -->
				<div class="input-toggle-bx2">
					<mat-icon id="handle-icon">apps</mat-icon>
					<input (ngModelChange)="onInputChange()" [(ngModel)]="subCat.name" name="name" matInput required>
					<div id="delete-bx">
						<mat-icon (click)="remove(i)">delete</mat-icon>
					</div>
					<div id="toggle-bx">
						<mat-slide-toggle [checked]="subCat.visible" (change)="changeSubCatVisibility($event , i)"></mat-slide-toggle>
					</div>
				</div>
			</div>
		</div>

		
	</div>
</div>

<div mat-dialog-actions class="actions-btns">
    <button mat-button cdkFocusInitial (click)="delete()" [hidden]="!this.category.id">Delete</button>
    <button class="cancel-btn" mat-button (click)="close()">Cancel</button>
    <button class="save-btn" mat-button cdkFocusInitial (click)="submit()">Save</button>
</div>